import { useCookies } from "react-cookie";
import { AIRHELP_GLOBAL_COOKIE_DOMAIN } from "../../constants/cookies";

const LAST_ENQUIRY_COOKIE = "last_enquiry";
const LAST_ENQUIRY_COOKIE_EXPIRATION = 2 * 30 * 24 * 60 * 60 * 1000; // 2 months

export const useLastEnquiry = () => {
  const [cookies, setCookie, removeCookie] = useCookies([LAST_ENQUIRY_COOKIE]);
  const lastEnquiryUuid = cookies[LAST_ENQUIRY_COOKIE];

  const setLastEnquiryCookie = (uuid: string) =>
    setCookie(LAST_ENQUIRY_COOKIE, uuid, {
      path: "/",
      domain: AIRHELP_GLOBAL_COOKIE_DOMAIN,
      expires: new Date(Date.now() + LAST_ENQUIRY_COOKIE_EXPIRATION),
    });

  const clearLastEnquiryCookie = () =>
    removeCookie(LAST_ENQUIRY_COOKIE, {
      path: "/",
      domain: AIRHELP_GLOBAL_COOKIE_DOMAIN,
    });

  return {
    lastEnquiryUuid,
    setLastEnquiryCookie,
    clearLastEnquiryCookie,
  };
};
